import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { UserPlus, Spinner } from '@phosphor-icons/react';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    username: '',
    password: '',
    first_name: '',
    last_name: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await register(formData);
    setLoading(false);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="login-split-screen">
      <div className="flex items-center justify-center bg-white p-8">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <h1 className="text-4xl font-black tracking-tight text-zinc-900 mb-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Domain Manager
            </h1>
            <p className="text-zinc-600 font-medium">Crear nueva cuenta</p>
          </div>

          <div className="bg-white border border-zinc-200 rounded-lg p-8">
            <h2 className="text-2xl font-bold tracking-tight mb-6" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Registro
            </h2>

            {error && (
              <div data-testid="register-error" className="mb-4 p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="label">Email</label>
                <input
                  data-testid="register-email-input"
                  type="email"
                  name="email"
                  className="input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-4">
                <label className="label">Usuario</label>
                <input
                  data-testid="register-username-input"
                  type="text"
                  name="username"
                  className="input"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="label">Nombre</label>
                  <input
                    data-testid="register-firstname-input"
                    type="text"
                    name="first_name"
                    className="input"
                    value={formData.first_name}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="label">Apellido</label>
                  <input
                    data-testid="register-lastname-input"
                    type="text"
                    name="last_name"
                    className="input"
                    value={formData.last_name}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="mb-6">
                <label className="label">Contraseña</label>
                <input
                  data-testid="register-password-input"
                  type="password"
                  name="password"
                  className="input"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  minLength={6}
                />
              </div>

              <button
                data-testid="register-submit-button"
                type="submit"
                disabled={loading}
                className="btn-primary w-full flex items-center justify-center gap-2"
              >
                {loading ? (
                  <Spinner className="animate-spin" size={20} />
                ) : (
                  <>
                    <UserPlus size={20} />
                    <span>Crear Cuenta</span>
                  </>
                )}
              </button>
            </form>

            <div className="mt-6 text-center">
              <p className="text-sm text-zinc-600">
                ¿Ya tienes cuenta?{' '}
                <Link to="/login" className="text-[#002FA7] font-semibold hover:underline">
                  Inicia sesión
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div 
        className="login-image-side bg-cover bg-center relative"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1532456745301-b2c645d8b80d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHdoaXRlJTIwYXJjaGl0ZWN0dXJhbCUyMGdyaWR8ZW58MHx8fHwxNzgyMzQ0MDk0fDA&ixlib=rb-4.1.0&q=85)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#002FA7]/20 to-transparent"></div>
      </div>
    </div>
  );
};

export default Register;